import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assests/img/logo.png';
import { NavLink, Link } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer'

export default function Asjsbookingform() {
  return (
    <div>
       <Header/>
      <iframe src="https://aadikaash.com/backend/aije-2025-booking-form/" className='iframe-box'></iframe>
      <Footer/>
    </div>
  )
}
